import styled from 'styled-components';

import {ContentStyled} from '../../styles/components/content.style';
import {media} from '../../styles/components/media-queries';
import {isIE11} from '../../helpers/ie.helper';

export const ConfirmationPageContentStyled = ContentStyled.extend`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
  border: ${p => p.theme.confirmationPage.border};
  color: ${props => props.theme.quinaryColor};
  background: ${props => props.theme.primaryBackground};
  width: ${props => props.theme.confirmationPage.width};
  max-width: 100vw;
  ${media.small`
    width: 100%;
  `};
`;

export const OrderDescription = styled.div`
  padding-bottom: ${props => props.theme.padding};
  text-align: center;
  a {
    cursor: pointer;
    color: ${props => props.theme.confirmationPage.linkColor};
  }
`;

export const OrderTrackerWrapper = styled.div`
  padding: ${props => props.theme.padding};
  width: ${p => p.theme.confirmationPage.trackerBlock.width};
  margin-bottom: ${p => p.theme.confirmationPage.trackerBlock.marginBottom};
  position: relative;
  ${media.small`
    width: 100%;
    padding-left: 0;
    padding-right: 0;
  `};
`;

export const Header = styled.div`
  min-height: 13.4rem;
  width: 100%;
`;

export const Title = styled.div`
  color: ${props => props.theme.quinaryColor};
  padding: ${props => props.theme.padding};
  font-size: ${props => props.theme.fontSizes.pageTitle};
  text-transform: uppercase;
  text-align: center;
`;

export const OrderPriceSummaryWrapper = styled.div`
  padding: ${props => props.theme.padding} 0;
`;

export const OrderPriceSummaryStyled = styled.div`
  border-top: 1px solid ${props => props.theme.borderColor};
  padding-top: ${props => props.theme.padding};
  display: flex;
  flex-direction: column;
`;

export const PriceSummaryItem = styled.div`
  display: flex;
  justify-content: space-between;
  text-transform: ${p => p.theme.confirmationPage.summaryBlock.textTransform};
  padding-top: ${p => p.theme.confirmationPage.summaryBlock.padding};
`;

export const ItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 0;
`;

export const ItemQuantity = styled.div`
  width: 4rem;
  padding-right: ${props => props.theme.padding};
  white-space: nowrap;
`;

export const Item = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
`;

export const Comment = styled.div`
  font-style: italic;
  ::before {
    content: '" ';
  }
  ::after {
    content: ' "';
  }
`;

export const ItemPrice = styled.div`
  padding-left: ${props => props.theme.padding};
`;

export const ItemDetails = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const OptionsList = styled.ul`
  margin: 0;
  -webkit-margin-before: 0;
  -webkit-margin-after: 0;
  -webkit-padding-start: 1.4rem;
`;

export const ItemOptions = styled.span`
  display: block;
  color: ${props => props.theme.quaternaryColor};
  font-size: ${props => props.theme.sideBasket.option.fontSize};
`;

export const ConsumerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  & > * {
    padding: ${props => props.theme.padding};
  }
`;

export const OrderSummaryStyled = styled.div`
  display: flex;
  width: 100%;
  ${media.small`
    flex-direction: column;
  `}
`;

export const NoFee = styled.img`
  width: 13.9rem;
  height: 11.7rem;
  padding: 1.2rem;
`;

export const Left = styled.div`
  min-width: 60%;
  margin-right: ${p => p.theme.confirmationPage.summaryBlock.margin};
`;

export const Right = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: ${p => p.theme.confirmationPage.infoBlock.justifyContent};
  align-items: center;
  padding-left: 1.2rem;
  flex-grow: 1;
  ${isIE11() && `
    width: 100%;
  `}
`;



// WEBPACK FOOTER //
// ./containers/ConfirmationPage/ConfirmationPage.style.js